import { environment } from '@environment';

export const billingApi = {
  get_billing: `${environment.api.travel_data_info}/billing/{billingId}`,
  default_billing: `${environment.api.travel_data_info}/billing/last`,
  create_billing: `${environment.api.travel_data_info}/billing`,
  update_billing: `${environment.api.travel_data_info}/billing/{billingId}`,
  list_by_user: `${environment.api.travel_data_info}/billing/by-user/{userId}`,
  delete_billing: `${environment.api.travel_data_info}/billing/{billingId}`,
  travel_order_billing: {
    create_order_billing: `${environment.api.travel_order_billing}/`
  },
};
